import { render, staticRenderFns } from "./casesBlock.vue?vue&type=template&id=7b790516&scoped=true"
import script from "./casesBlock.vue?vue&type=script&lang=js"
export * from "./casesBlock.vue?vue&type=script&lang=js"
import style0 from "./casesBlock.vue?vue&type=style&index=0&id=7b790516&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b790516",
  null
  
)

export default component.exports